import React, { useRef, useState, useEffect} from 'react';

import PartnerView from '../../views/PartnerViews';

import { usePartnerContext } from '../../components/Context/PartnerContext';




const PartnerComponent = () => {
    const data = useRef('');
    const [loading,setLoading] = useState(true);
    const didFetch = useRef(false); 

    const error = useRef('');
    const { partners, FetchPartners } = usePartnerContext();
    const getData = async () => {
        
        try {
     
    //         const response = await fetchPartner();
    //         data.current = response.data;
                await FetchPartners();
                setLoading(false); // Set loading to false once data is fetched
   
    //         console.log(response.data);
        
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current= 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
          getData();    
          didFetch.current = true; // Mark the API call as done
        }
      });
    
    
    return <div>
   {/* {loading && <div>Loading...</div>}*/}
    {!loading && partners!=null && <PartnerView Partnersdata={partners} />}
    </div>
    // return <PartnerView Partnersdata={partners}/>
   
};

export default PartnerComponent;
